import { v4 as uuidv4 } from "uuid";

// Generate a single initId that will be shared across all analytics services
let sharedInitId: string | null = null;

export function getSharedInitId(): string {
  if (!sharedInitId) {
    sharedInitId = uuidv4();
  }
  return sharedInitId;
}
